import { Extra } from '@common/components/Extras';
import { ExtrasCategoryTitle } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/ExtrasCategoryTitle';
import { useWatch } from 'react-hook-form';
import { MultiRoomSearch } from 'shared-types';
import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { OptionsV2 } from './Options/OptionsV2';
import { MultiRoomPerStayV2 } from './PerStay/MultiRoomPerStayV2';
import { PerStayV2 } from './PerStay/PerStayV2';

type ExtrasV2Props = {
  extras?: RoomExtra[] | null;
  isMultiRoom: boolean;
  rooms?: MultiRoomSearch;
};

export const ExtrasV2 = ({ extras, isMultiRoom, rooms = [] }: ExtrasV2Props) => {
  const extrasValues = useWatch({ name: 'extras' }) ?? [];

  return (
    <>
      {extras &&
        extras.map((extra, index) => {
          const extraValues = Array.isArray(extrasValues) ? extrasValues[index] : undefined;
          const isSelected = extraValues?.isSelected;
          const selectedOptionIndex = extraValues?.option;
          const selectedExtraOption =
            'options' in extra
              ? (extra.options?.[selectedOptionIndex] as RoomExtraOption | undefined)
              : undefined;

          return (
            <div key={extra.id ?? index}>
              <ExtrasCategoryTitle extras={extras} index={index} />
              <Extra
                featured
                showPrice
                controls={(() => {
                  switch (extra.type) {
                    case 'per_stay': {
                      return isMultiRoom ? (
                        <MultiRoomPerStayV2
                          id={index}
                          maxQuantity={extra.maxQuantity}
                          pricingType={extra.pricingType ?? 'per_stay'}
                          rooms={rooms}
                        />
                      ) : (
                        <PerStayV2 id={index} maxQuantity={extra.maxQuantity} />
                      );
                    }
                    default: {
                      return (
                        <OptionsV2 {...extra} selectedOption={selectedExtraOption} id={index} />
                      );
                    }
                  }
                })()}
                isSelected={isSelected}
                {...(extra as any)}
              />
            </div>
          );
        })}
    </>
  );
};
